import type { Theme } from '../../types/theme';

export const slackTheme: Theme = {
  id: 'slack',
  name: 'Slack',
  description: 'Deep aubergine primary with cream-lavender gradients and pill CTAs',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/slack/DESIGN.md',
  visualKeywords: ['aubergine', 'pill buttons', 'lavender gradients', 'humanist sans', 'collaboration'],
  colors: {
    background: '#ffffff',
    surface: '#ffffff',
    surfaceElevated: '#ffffff',
    textPrimary: '#1d1d1d',
    textSecondary: '#696969',
    textMuted: '#696969',
    border: '#e6e6e6',
    borderSubtle: '#dcdcdc',
    primary: '#4a154b',
    primaryHover: '#59245a',
    primaryActive: '#2c002d',
    accent: '#4a154b',
    onPrimary: '#ffffff',
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
  },
  typography: {
    headingFont: 'Inter, system-ui, sans-serif',
    bodyFont: 'Inter, system-ui, sans-serif',
    monoFont: 'JetBrains Mono, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-0.02em',
    letterSpacingBody: '0',
  },
  radius: {
    button: '6px',
    card: '8px',
    panel: '8px',
    badge: '4px',
    input: '6px',
  },
  shadow: {
    card: '0 1px 3px rgba(0,0,0,0.1)',
    elevated: '0 4px 12px rgba(0,0,0,0.15)',
    button: '0 1px 2px rgba(0,0,0,0.1)',
    none: 'none',
  },
  layout: {
    maxWidth: '1280px',
    sectionSpacing: '80px',
    cardPadding: '24px',
    navHeight: '64px',
  },
  mood: {
    density: 'medium',
    tone: 'collaborative',
    productFit: [],
    bestFor: [],
    notGoodFor: [],
  },
};
